// extracted by mini-css-extract-plugin
export default {"bingo":"lT9Cu","playfield":"Nxk-5","bingoText":"_8Jo-T","bingoTextVisible":"fhijW","bounceIn":"_8Gl6Y","counters":"_8d7mq","form":"uh2Qr","tile":"HoZfi"};